import { Icon } from '../ui/Icon'
import { setRailConcise, useRailConcise } from './railConcise'

/**
 * The rail header's Concise switch, left of the theme's (owner, 2026-11-04). Like the sun and moon beside it, the glyph
 * shows the rail as it IS — two tall rows while each agent shows its last message, thin lines while concise — and the
 * title says what a press does. `aria-pressed` carries the state for a screen reader.
 */
export function ConciseButton() {
  const concise = useRailConcise()
  return (
    <button
      type="button"
      id="sbConcise"
      title={concise ? 'Show last messages' : 'Concise — hide last messages and member lists to see more'}
      aria-label="Concise list"
      aria-pressed={concise}
      onClick={() => setRailConcise(!concise)}
    >
      <Icon name={concise ? 'view_headline' : 'view_agenda'} size={17} />
    </button>
  )
}
